var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "room-doc-list-component",
      attrs: { "data-grm-comp": "List" },
    },
    [
      _c(
        "ul",
        { staticClass: "room-doc-list" },
        _vm._l(_vm.roomDoc.roomDocFiles, function (roomDocFile) {
          return _c(
            "li",
            {
              key: roomDocFile.docId,
              staticClass: "room-doc-item",
              class: [
                roomDocFile.docType,
                { selected: roomDocFile.docId === _vm.roomDoc.docId },
              ],
              attrs: { "data-docId": roomDocFile.docId },
            },
            [
              _c("div", {
                staticClass: "room-doc-select-button",
                on: {
                  click: function ($event) {
                    return _vm.onClickFile(roomDocFile)
                  },
                },
              }),
              _c(
                "div",
                { staticClass: "room-doc" },
                [
                  _vm.isDocFileConverted(roomDocFile) ||
                  roomDocFile.docFile.docConvPageCnt > 0
                    ? _c(
                        "lazy-component",
                        {
                          staticClass: "room-doc-thumb",
                          on: {
                            show: function ($event) {
                              return _vm.loadRoomDocFileThumbnail(
                                roomDocFile,
                                $event
                              )
                            },
                          },
                        },
                        [_c("img")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c("div", { staticClass: "room-doc-title-wrapper" }, [
                _c(
                  "p",
                  { staticClass: "room-doc-title" },
                  [
                    _vm._v(_vm._s(roomDocFile.docName) + " "),
                    _vm.hasDocFilePage(roomDocFile)
                      ? [
                          _vm._v(
                            "(" +
                              _vm._s(roomDocFile.currDocPageSeq) +
                              "/" +
                              _vm._s(
                                roomDocFile.docFile.docPageCnt > 0
                                  ? roomDocFile.docFile.docPageCnt + "p"
                                  : "..."
                              ) +
                              ")"
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ]),
              _vm.isDocFileConverting(roomDocFile)
                ? _c("div", { staticClass: "room-doc-progress" }, [
                    roomDocFile.docFile.docPageCnt > 0
                      ? _c("div", {
                          staticClass: "room-doc-progress-bar",
                          style: {
                            width: `${
                              (roomDocFile.docFile.docConvPageCnt /
                                roomDocFile.docFile.docPageCnt) *
                              100
                            }%`,
                          },
                        })
                      : _vm._e(),
                    _c("div", { staticClass: "room-doc-progress-text" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("doc.list.transform.ongoing"))),
                      ]),
                      _c("span", [
                        _vm._v(
                          " - " +
                            _vm._s(roomDocFile.docFile.docConvPageCnt) +
                            "/" +
                            _vm._s(
                              roomDocFile.docFile.docPageCnt > 0
                                ? roomDocFile.docFile.docPageCnt
                                : "..."
                            ) +
                            " "
                        ),
                      ]),
                    ]),
                  ])
                : roomDocFile.docFile && roomDocFile.docFile.docState === 0
                ? _c("div", { staticClass: "room-doc-progress" }, [
                    _c("div", { staticClass: "room-doc-progress-text" }, [
                      _vm._v(_vm._s(_vm.$t("doc.list.transform.ready"))),
                    ]),
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticClass: "room-doc-button-wrapper" },
                [
                  _c("button", {
                    staticClass: "room-doc-button",
                    on: {
                      click: function ($event) {
                        return _vm.onToggleModal(roomDocFile)
                      },
                    },
                  }),
                  _c("GrmMenu", {
                    attrs: {
                      open: _vm.isShowMoreModal[roomDocFile.docId],
                      list: _vm.modalList(roomDocFile),
                    },
                    on: {
                      "update:open": function ($event) {
                        return _vm.$set(
                          _vm.isShowMoreModal,
                          roomDocFile.docId,
                          $event
                        )
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }